import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=1869fdb3&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=1869fdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1869fdb3",
  null
  
)

export default component.exports